import FlyerPrintTemplatePFJoinCode from './FlyerPrintTemplatePFJoinCode';
import FlyerPrintTemplatePFNoJoinCode from './FlyerPrintTemplatePFNoJoinCode';
import FlyerPrintTemplateWGJoinCode from './FlyerPrintTemplateWGJoinCode';
import FlyerPrintTemplateWGNoJoinCode from './FlyerPrintTemplateWGNoJoinCode';
import FlyerPrintTemplateSellPhotosJoinCode from './FlyerPrintTemplateSellPhotosJoinCode';
import FlyerPrintTemplateSellPhotosNoJoinCode from './FlyerPrintTemplateSellPhotosNoJoinCode';
import FlyerPrintTemplateSBJoinCode from './FlyerPrintTemplateSBJoinCode';
import FlyerPrintTemplateSBNoJoinCode from './FlyerPrintTemplateSBNoJoinCode';
import { isAlbumFolderForWebGalleryOnly } from '../../../../../../../../util/album-folder';
import { isHumanJoinCode } from '../../../../../../../../util/join-code';
import FlyerPrintTemplateNoWGJoinCode from './FlyerPrintTemplateNoWGJoinCode';
import FlyerPrintTemplateNoWGNoJoinCode from './FlyerPrintTemplateNoWGNoJoinCode';
import { ALL_PHOTOS_MODE } from '../../../../../../../../constants/album-folder';
import FlyerPrintTemplateMatchesWG from './FlyerPrintTemplateMatchesWG';
import FlyerPrintTemplateNoFRWG from './FlyerPrintTemplateNoFRWG';
import { getUtmParamsForQrCodeUrl } from '../helpers';
import getConfig from '../../../../../../../../util/config';

const templateConfiguration = [
  {
    name: 'SB Without Join Code',
    component: FlyerPrintTemplateSBNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.search_subscription_credits_joins_enabled,
    getQrCodeValue: ({ albumFolder, account }) =>
      getUtmParamsForQrCodeUrl({
        url: `https://waldophotos.com/@${account?.username}`,
        albumFolder,
      }),
  },
  {
    name: 'No Face Rec + WG',
    component: FlyerPrintTemplateNoFRWG,
    when: albumFolder =>
      albumFolder.picture_day_enabled &&
      albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
      !albumFolder.joins_enabled,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: albumFolder.web_app_urls?.all_photos_access_url,
        albumFolder,
      }),
  },
  {
    name: 'Matched photos + WG',
    component: FlyerPrintTemplateMatchesWG,
    when: albumFolder =>
      albumFolder.picture_day_enabled &&
      albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
      albumFolder.joins_enabled &&
      isHumanJoinCode(albumFolder.join_code),
    getQrCodeValue: ({ albumFolder }) =>
      `${getConfig().app.baseUrl}/galleries/o/album-folder/${albumFolder.id}`,
  },
  {
    name: 'SB With Join Code',
    component: FlyerPrintTemplateSBJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.search_subscription_credits_joins_enabled,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'Sell Photos Without Join Code',
    component: FlyerPrintTemplateSellPhotosNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.picture_day_enabled,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url:
          albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
          !albumFolder.joins_enabled
            ? `${getConfig().app.baseUrl}/s/all-photos-access/${albumFolder.id}`
            : albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'Sell Photos With Join Code',
    component: FlyerPrintTemplateSellPhotosJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && albumFolder.picture_day_enabled,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url:
          albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC &&
          !albumFolder.joins_enabled
            ? `${getConfig().app.baseUrl}/s/all-photos-access/${albumFolder.id}`
            : albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'WG Only Without Join Code',
    component: FlyerPrintTemplateWGNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.is_web_gallery &&
      !albumFolder?.price?.value &&
      isAlbumFolderForWebGalleryOnly(albumFolder),
    getQrCodeValue: ({ albumFolder }) => {
      const isPublicAllPhotos =
        albumFolder.all_photos_mode === ALL_PHOTOS_MODE.PUBLIC;
      const isWebGalleryOrPublic =
        albumFolder.is_web_gallery || isPublicAllPhotos;

      let url;
      if (isWebGalleryOrPublic && !albumFolder.joins_enabled) {
        url = albumFolder?.web_app_urls?.all_photos_access_url;
      } else if (albumFolder.joins_enabled && !isWebGalleryOrPublic) {
        url = albumFolder?.onboarding_short_url;
      } else {
        url = `${getConfig().app.baseUrl}/galleries/o/album-folder/${
          albumFolder.id
        }`;
      }

      return getUtmParamsForQrCodeUrl({ url, albumFolder });
    },
  },
  {
    name: 'WG Only With Join Code',
    component: FlyerPrintTemplateWGJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) &&
      albumFolder.is_web_gallery &&
      !albumFolder?.price?.value &&
      isAlbumFolderForWebGalleryOnly(albumFolder),
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: `https://waldophotos.com/galleries${
          albumFolder.join_code &&
          !albumFolder.public_join_code_verification_enabled
            ? `?joinCode=${albumFolder.join_code}`
            : ''
        }`,
        albumFolder,
      }),
  },
  {
    name: 'Photo Finder With Join Code + Web Gallery',
    component: FlyerPrintTemplatePFJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && albumFolder.is_web_gallery,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'Photo Finder With Join Code, No Web Gallery',
    component: FlyerPrintTemplateNoWGJoinCode,
    when: albumFolder =>
      isHumanJoinCode(albumFolder.join_code) && !albumFolder.is_web_gallery,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'Photo Finder Without Join Code, No Web Gallery',
    component: FlyerPrintTemplateNoWGNoJoinCode,
    when: albumFolder =>
      !isHumanJoinCode(albumFolder.join_code) && !albumFolder.is_web_gallery,
    getQrCodeValue: ({ albumFolder }) =>
      getUtmParamsForQrCodeUrl({
        url: albumFolder.onboarding_short_url,
        albumFolder,
      }),
  },
  {
    name: 'Default case (profile page)',
    component: FlyerPrintTemplatePFNoJoinCode,
    when: () => true,
    getQrCodeValue: ({ albumFolder, account }) =>
      getUtmParamsForQrCodeUrl({
        url: `https://waldophotos.com/@${account?.username}`,
        albumFolder,
      }),
  },
];

/**
 * Fetches the correct print template component to be used with the Flyer prints for marketing materials.
 *
 * @param {Object} options The options.
 * @param {Object} options.albumFolder The AlbumFolder.
 * @returns {{component: function({albumFolder: *}): *, name: string, when: function(*): *}|{component: function({albumFolder: *}): *, name: string, when: function(*): *}|null}
 */
export const getAccountMarketingMaterialFlyerPrintTemplateComponent = ({
  albumFolder,
}) => {
  const template =
    templateConfiguration.find(config => config.when(albumFolder)) ?? {};
  const { component } = template;
  return component ?? null;
};

/**
 * Returns the QR code value (URL) the flyer print template would use for the
 * given albumFolder, following the same per-vertical rules used to pick the
 * flyer template. Used by custom-design flyers so their QR matches the
 * default material's behavior.
 *
 * @param {Object} options The options.
 * @param {Object} options.albumFolder The AlbumFolder.
 * @param {Object} options.account The Account owning the material.
 * @returns {String}
 */
export const getAccountMarketingMaterialFlyerQrCodeValue = ({
  albumFolder,
  account,
}) => {
  const template =
    templateConfiguration.find(config => config.when(albumFolder)) ?? {};

  return template.getQrCodeValue?.({ albumFolder, account }) ?? '';
};
